import { Text, View } from "react-native";

export const ReviewRow = ({
  label,
  value,
}: {
  label: string;
  value?: React.ReactNode;
}) => (
  <View className="flex-row py-3 border-b border-ash-3 mb-1">
    <Text className="text-xs text-onyx w-32 pt-0.5">{label}</Text>
    <View className="flex-1">
      {typeof value === "string" || typeof value === "number" ? (
        <Text className="text-sm font-medium text-onyx">{value || "—"}</Text>
      ) : (
        (value ?? <Text className="text-sm text-onyx">—</Text>)
      )}
    </View>
  </View>
);
